window.translate = function(string, interpolation = {}){
  return interpolate(env.data.translations[string] || string, interpolation).replaceAll('␣', ' ');
}

function interpolate (value, options) {
  if (options === [] || options === {}) {
    return value;
  }

  Object.keys(options).forEach((key) => {
    value = value.replace(':' + key, options[key])
  })

  return value;
}

/////////////////////////////////
// Polyfills
/////////////////////////////////
const env = require("app/services/env");
const polyfill = require("app/polyfill");

if (env.client()) {
	polyfill();
}

/////////////////////////////////
// Debugger
/////////////////////////////////

const debug = require("app/services/debugger");

debug.expose({
	axios: require("axios"),
	router: require("app/services/router"),
	env: require("app/services/env"),
	cookie: require("app/services/cookie"),
	moment: require("moment")
});

/////////////////////////////////
// Register components
/////////////////////////////////

const renderer = require("app/services/renderer");

renderer.register("web", {
	Notifications: require("app/components/Notifications"),

	// Menus
	menus: {
		ShopNavigation: require("app/components/menus/ShopNavigation"),
		CartItem: require("app/components/menus/CartItem"),
		SearchItem: require("app/components/menus/SearchItem"),
		BurgerItem: require("app/components/menus/BurgerItem")
	},

	// Modals
	modals: {
		Container: require("app/components/modals/ModalContainer")
	},

	// Products
	products: {
		Related: require("app/components/products/RelatedProducts"),
		Popular: require("app/components/products/PopularProducts"),
		PopularAlt: require("app/components/products/PopularProductsAlternative"),
		DynamicList: require("app/components/products/DynamicProductList"),
		SingleProduct: require("app/components/products/SingleProduct"),
		List: require("app/components/products/ProductList"),

		triggers: require("app/components/products/FilterTriggers"),

		filters: {
			Category: require("app/components/products/filters/CategoryFilter"),
			Color: require("app/components/products/filters/ColorFilter"),
			Gender: require("app/components/products/filters/GenderFilter"),
			Order: require("app/components/products/filters/OrderFilter"),
			Price: require("app/components/products/filters/PriceFilter"),
		},

		widgets: {
			Delivery: require("app/components/products/widgets/DeliveryWidget"),
			Configuration: require("app/components/products/configuration/Widget"),
			ConfigurationMobile: require("app/components/products/configuration-mobile/Widget")
		}
	},

	// Posts
	posts: {
		Latest: require("app/components/posts/LatestPosts"),
		DynamicList: require("app/components/posts/DynamicPostList")
	},

	widgets: {
		DeliveryTimeChecker: require("app/components/widgets/DeliveryTimeChecker"),
		AltDeliveryTimeChecker: require("app/components/widgets/AltDeliveryTimeChecker"),
		NewDeliveryTimeChecker: require("app/components/widgets/NewDeliveryTimeChecker"),
		Map: require("app/components/widgets/Map"),
		search: {
			Manager: require("app/components/widgets/search/SearchManager"),
			CloseTrigger: require("app/components/widgets/search/CloseTrigger"),
			Mobile: require("app/components/widgets/search/MobileSearch")
		},
		SidebarTrigger: require("app/components/widgets/SidebarTrigger"),
		CloseTrigger: require("app/components/widgets/CloseTrigger"),
		order: {
			Overview: require('app/components/widgets/order/Overview').default,
		},
	},

	forms: {    
		newsletter: require("app/components/forms/Newsletter"), 
		auth: require("app/components/forms/Auth"), 
		Profile: require("app/components/forms/Profile"), 
		BuyGiftcard: require("app/components/forms/BuyGiftcard"),
		Contact: require("app/components/forms/Contact"),
	}, 
	
	checkout: { 
		Manager: require("app/components/checkout/Manager")
	}

});

/////////////////////////////////
// Bootstrap
/////////////////////////////////

const logger = require("app/services/logger");

require("app/bootstrap").dispatch()
	.then(payload => {
		// At this point the application was bootstrapped and is ready.
		// You can require your javascript code here and be 100% sure it is ran in the browser.

		// require("path to my module")

		// Make sure you keep this return as it continues to pipe the payload
		// towards the end of the pipeline

		require("app/frontend/cta-bar").valentinesBar();
		require("app/frontend/cta-bar").mothersDayBar();
		require("app/frontend/cta-bar").topbanner();
		require("app/frontend/lazy-load").boot();
        require("app/frontend/embeds")();
		require("app/frontend/object-fit")();
		require("app/frontend/morningcatch")();
		require("app/frontend/mobile-keyboard");
		require("app/frontend/scroll-to")();
		require("app/frontend/cover-accordion")();

		return payload;
	})
	.then(() => {
		logger.info("The application was bootstrapped.")
	});
